import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Bonuses() {
  return <section className="bg-cream-50 py-16 md:py-24" data-id="element-103" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-4xl px-5" data-id="element-104" data-mp="1clzeqq4qz26l">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-navy-900 text-gold-400" data-id="element-105" data-mp="18jkvi4x620es">
          <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-106" data-mp="25adbl2k3nsgk" />
        </div>
        <h2 className="mt-5 text-center font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-107" data-mp="257hcvc0fgzr2">
          5 exclusive bonuses — <em className="text-gold-700" data-id="element-108" data-mp="1w8duka934odm">free today</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] text-muted" data-id="element-109" data-mp="1ra2jxxayu9uc">
          Total value <span className="font-bold text-red-600 line-through" data-id="element-110" data-mp="1rcex7x5s3w12">$147</span> · included free with your purchase today.
        </p>
      </div>

      <ol className="mx-auto mt-12 max-w-4xl space-y-14 md:space-y-20" data-id="element-111" data-mp="funlsq70tbxn">
        {bonuses.map(b => <li key={b.number} data-id="element-112" data-mp="1euq0ycrg1814">
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full md:rounded-3xl" loading="lazy" data-id="element-113" data-mp="1eug8miixeos9" />
            <div className="px-5 pt-5 md:px-8" data-id="element-114" data-mp="15syxzfoaffay">
              <div className="flex flex-wrap items-center gap-2" data-id="element-115" data-mp="15s6znx3b33gz">
                <span className="rounded-md bg-navy-900 px-2.5 py-1 text-xs font-extrabold uppercase tracking-wider text-gold-300" data-id="element-116" data-mp="1arjylg7gc0zx">
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-semibold text-muted" data-id="element-117" data-mp="10tlztyryult2">
                  Value <span className="text-red-600 line-through" data-id="element-118" data-mp="10vynmskenqe1">${b.value}</span>{" "}
                  <span className="font-extrabold text-emerald-700" data-id="element-119" data-mp="n4bu30hukvyy">FREE</span>
                </span>
              </div>
              <h3 className="mt-3 font-serif text-2xl font-bold leading-tight text-navy-950 md:text-3xl" data-id="element-120" data-mp="r1pymeul2fkm">{b.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-121" data-mp="i34jyus8fkp4">{b.text}</p>
            </div>
          </li>)}
      </ol>

      <div className="px-5" data-id="element-122" data-mp="2jtd7lxnmqx7e">
        <CtaButton className="mt-14" label="I want all 5 bonuses free" data-id="element-123" data-mp="2juo91qtlrsvc" />
      </div>
    </section>;
}